// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"600dbad5","769":"5643bebf"}[chunkId] + ".chunk.css";
};